import React from "react";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import MenuSurface from "./MenuSurface";
export default function ChoiceMenu({
  value,
  options,
  onChange,
  label,
  children,
  className,
  variant,
  endIcon,
  iconOnly = false,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const id = React.useId();
  const Trigger = iconOnly ? IconButton : Button;
  return (
    <div className={className}>
      <Trigger
        type="button"
        {...(iconOnly ? {} : { variant, endIcon })}
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={!!anchorEl}
        aria-controls={anchorEl ? id : undefined}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {children}
      </Trigger>
      {anchorEl && (
        <MenuSurface
          id={id}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
        >
          {options.map((option) => {
            const val = typeof option === "string" ? option : option.value;
            return (
              <MenuItem
                key={val}
                component="button"
                type="button"
                selected={val === value}
                aria-pressed={val === value}
                onClick={() => {
                  onChange(val);
                  setAnchorEl(null);
                }}
              >
                {typeof option === "string" ? option : option.label}
              </MenuItem>
            );
          })}
        </MenuSurface>
      )}
    </div>
  );
}
